/* MotoGP™ page script (2026-10-03). Loaded by each motogp-* section; the guard runs it once.
   Tabs, points calculator, title maths, calendar status/filter/.ics, the hero's "Next race" card, glossary search. */
(function () {
  if (window.__kbMotoGP) return;
  window.__kbMotoGP = true;

  var DAY = 864e5;
  var GP = [25, 20, 16, 13, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
  var SPRINT = [12, 9, 7, 6, 5, 4, 3, 2, 1];
  var MAX_WEEKEND = 37;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parseDay(s) {
    var p = String(s || '').split('-');
    return p.length === 3 ? Date.UTC(+p[0], +p[1] - 1, +p[2]) : NaN;
  }
  function today() { var d = new Date(); return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(ms) { var d = new Date(ms); return d.getUTCFullYear() + pad(d.getUTCMonth() + 1) + pad(d.getUTCDate()); }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }

  function readRounds() {
    var el = $('script[data-mgp-rounds]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }

  /* Status of every round from the visitor's own date. race day = Sunday, weekend = Friday to Sunday. */
  function annotate(rounds) {
    var t = today(), nextFound = false;
    return rounds.map(function (r) {
      var race = parseDay(r.date), diff = Math.round((race - t) / DAY), status;
      if (isNaN(race)) status = 'upcoming';
      else if (diff < 0) status = 'done';
      else status = 'upcoming';
      var out = { r: r, race: race, diff: diff, status: status, next: false };
      if (status !== 'done' && !nextFound && !isNaN(race)) { out.next = true; nextFound = true; }
      return out;
    });
  }

  function whenText(a) {
    if (a.diff === 0) return 'Race day';
    if (a.diff > 0 && a.diff <= 2) return 'This weekend';
    return 'In ' + plural(a.diff, 'day');
  }

  /* ---------- Hero: next race card ---------- */
  function initNext(list) {
    var card = $('[data-mgp-next]');
    if (!card) return;
    var next = list.filter(function (a) { return a.next; })[0];
    if (!list.length) return;
    var tag = $('[data-mgp-next-tag]', card), when = $('[data-mgp-next-when]', card), gp = $('[data-mgp-next-gp]', card), where = $('[data-mgp-next-where]', card);
    if (!next) {
      var last = list[list.length - 1].r;
      tag.textContent = 'Season complete';
      when.textContent = 'See you in March';
      gp.textContent = 'The ' + (last.date || '').slice(0, 4) + ' season is done';
      where.textContent = '';
    } else {
      tag.textContent = next.diff >= 0 && next.diff <= 2 ? 'Racing now' : 'Next race';
      when.textContent = whenText(next);
      gp.textContent = next.r.gp;
      where.textContent = [next.r.circuit, next.r.country].filter(Boolean).join(' · ');
    }
    card.hidden = false;
  }

  /* ---------- Calendar ---------- */
  function initCalendar(list) {
    var root = $('[data-mgp-cal]');
    if (!root) return;
    var items = $$('[data-mgp-round]', root);
    var count = $('[data-mgp-cal-count]', root);
    var filters = $('[data-mgp-filters]', root);
    var ics = $('[data-mgp-ics]', root);
    var current = 'all';

    items.forEach(function (li, i) {
      var a = list[i];
      if (!a) return;
      li.setAttribute('data-status', a.status);
      var st = $('[data-mgp-status]', li);
      if (a.status === 'done') { st.textContent = 'Raced'; }
      else if (a.next) { li.setAttribute('data-next', 'true'); st.textContent = whenText(a); }
      else { st.textContent = ''; }
    });

    function apply() {
      var shown = 0;
      items.forEach(function (li) {
        var s = li.getAttribute('data-status') || 'upcoming';
        var show = current === 'all' || s === current;
        li.hidden = !show;
        if (show) shown++;
      });
      if (count) count.textContent = 'Showing ' + plural(shown, 'round') + ' of ' + items.length;
    }
    if (filters) {
      filters.hidden = false;
      $$('[data-mgp-filter]', filters).forEach(function (b) {
        b.addEventListener('click', function () {
          current = b.getAttribute('data-mgp-filter');
          $$('[data-mgp-filter]', filters).forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          apply();
        });
      });
    }
    apply();

    if (ics && list.length) {
      ics.hidden = false;
      ics.addEventListener('click', function () {
        var season = root.getAttribute('data-season') || '';
        var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Kabuto Americas//MotoGP calendar//EN', 'CALSCALE:GREGORIAN', 'X-WR-CALNAME:MotoGP ' + season];
        function esc(s) { return String(s || '').replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n'); }
        list.forEach(function (a) {
          if (isNaN(a.race)) return;
          lines.push('BEGIN:VEVENT',
            'UID:motogp-' + season + '-' + a.r.n + '@kabutoamericas.com',
            'DTSTAMP:' + ymd(Date.now()) + 'T000000Z',
            'DTSTART;VALUE=DATE:' + ymd(a.race - 2 * DAY),
            'DTEND;VALUE=DATE:' + ymd(a.race + DAY),
            'SUMMARY:' + esc('MotoGP round ' + a.r.n + ': ' + a.r.gp),
            'LOCATION:' + esc([a.r.circuit, a.r.country].filter(Boolean).join(', ')),
            'DESCRIPTION:' + esc('Race weekend, Friday to Sunday. Dates can change: check motogp.com for session times.'),
            'END:VEVENT');
        });
        lines.push('END:VCALENDAR');
        var blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
        var url = URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url; link.download = 'motogp-' + season + '.ics';
        document.body.appendChild(link); link.click(); link.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 2000);
      });
    }
  }

  /* ---------- Race weekend: tabs + tools ---------- */
  function initWeekend(list) {
    var root = $('[data-mgp-weekend]');
    if (!root) return;
    root.classList.add('mgp--js');
    var tabs = $$('[role="tab"]', root), panels = $$('[data-mgp-panel]', root), tablist = $('[data-mgp-tablist]', root);
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[j].hidden = !on;
      });
      if (focus) tabs[i].focus();
    }
    if (tabs.length === panels.length && tabs.length) {
      tablist.hidden = false;
      select(0);
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var n = tabs.length, k = e.key, to = -1;
          if (k === 'ArrowRight' || k === 'ArrowDown') to = (i + 1) % n;
          else if (k === 'ArrowLeft' || k === 'ArrowUp') to = (i - 1 + n) % n;
          else if (k === 'Home') to = 0;
          else if (k === 'End') to = n - 1;
          if (to > -1) { e.preventDefault(); select(to, true); }
        });
      });
    }

    var tools = $('[data-mgp-tools]', root);
    if (tools) tools.hidden = false;

    var sp = $('[data-mgp-sprint]', root), gp = $('[data-mgp-gp]', root);
    var total = $('[data-mgp-total]', root), label = $('[data-mgp-total-label]', root);
    function calc() {
      var s = +sp.value, g = +gp.value;
      var pts = (s >= 0 ? SPRINT[s] : 0) + (g >= 0 ? GP[g] : 0);
      total.textContent = pts;
      label.textContent = pts === MAX_WEEKEND ? 'points: a perfect weekend' : 'points of a possible ' + MAX_WEEKEND;
    }
    if (sp && gp) { sp.addEventListener('change', calc); gp.addEventListener('change', calc); sp.value = '0'; gp.value = '0'; calc(); }

    var lead = $('[data-mgp-lead]', root), left = $('[data-mgp-left]', root), out = $('[data-mgp-title-out]', root);
    if (left && list.length) {
      var rem = list.filter(function (a) { return a.diff > 0; }).length;
      left.value = rem;
    }
    function title() {
      var l = Math.max(0, Math.floor(+lead.value || 0)), n = Math.max(0, Math.floor(+left.value || 0));
      var most = n * MAX_WEEKEND;
      if (n === 0) {
        out.innerHTML = '<strong>No weekends left.</strong> The championship is decided on the points already scored.';
      } else if (l > most) {
        out.innerHTML = '<strong>Mathematically decided.</strong> Even if the chaser won every Sprint and Grand Prix (' + most + ' points) and the leader scored nothing, ' + l + ' points is too many to catch.';
      } else {
        var per = (l / n).toFixed(1);
        out.innerHTML = '<strong>Still open.</strong> There are ' + most + ' points left to win. The chaser has to beat the leader by about ' + per + ' points per weekend; the most anyone can gain on a rival in one weekend is ' + MAX_WEEKEND + '.';
      }
    }
    if (lead && left && out) { lead.addEventListener('input', title); left.addEventListener('input', title); title(); }
  }

  /* ---------- Glossary search ---------- */
  function initGuide() {
    var root = $('[data-mgp-guide]');
    if (!root) return;
    var box = $('[data-mgp-search]', root), input = $('[data-mgp-search-input]', root);
    var terms = $$('[data-mgp-term]', root), count = $('[data-mgp-gloss-count]', root), empty = $('[data-mgp-gloss-empty]', root);
    if (!box || !input) return;
    box.hidden = false;
    function run() {
      var q = input.value.trim().toLowerCase(), shown = 0;
      terms.forEach(function (t) {
        var hit = !q || t.textContent.toLowerCase().indexOf(q) > -1;
        t.hidden = !hit;
        if (hit) shown++;
      });
      empty.hidden = shown !== 0;
      count.textContent = q ? plural(shown, 'term') + ' found' : '';
    }
    input.addEventListener('input', run);
  }

  /* ---------- Compact next-race band (rider pages): reads the MotoGP page's calendar once ---------- */
  function fillNext(root, list) {
    var next = list.filter(function (a) { return a.next; })[0], box = $('[data-mgp-mini-next]', root);
    if (!box) return;
    var tag = $('[data-mgp-next-tag]', box), when = $('[data-mgp-next-when]', box), gp = $('[data-mgp-next-gp]', box), where = $('[data-mgp-next-where]', box);
    if (!next) { tag.textContent = 'Season complete'; when.textContent = 'See you in March'; gp.textContent = ''; where.textContent = ''; }
    else {
      tag.textContent = next.diff >= 0 && next.diff <= 2 ? 'Racing now' : 'Next race';
      when.textContent = whenText(next); gp.textContent = next.r.gp;
      where.textContent = [next.r.circuit, next.r.country].filter(Boolean).join(' \u00b7 ');
    }
    box.hidden = false;
    root.classList.add('mgp-mini--live');
    var racing = !!(next && next.diff >= 0 && next.diff <= 2);
    $$('[data-mgp-rider-chip]', root).forEach(function (c) { c.hidden = !racing; });
  }
  function initMini(local) {
    var root = $('[data-mgp-mini]');
    if (!root) return;
    if (local.length) { fillNext(root, annotate(local.map(function (a) { return a.r; }))); return; }
    var src = root.getAttribute('data-source'), key = 'kb-mgp-rounds:' + src, cached = null;
    try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    if (cached && Date.now() - cached.t < 18e5) { fillNext(root, annotate(cached.r)); return; }
    var go = function () {
      fetch(src, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : Promise.reject(); }).then(function (html) {
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-mgp-rounds]');
        var rounds = el ? JSON.parse(el.textContent) : [];
        if (!rounds.length) return;
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), r: rounds })); } catch (e) {}
        fillNext(root, annotate(rounds));
      }).catch(function () {});
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 800);
  }

  function init() {
    var rounds = readRounds(), list = annotate(rounds);
    initNext(list);
    initCalendar(list);
    initWeekend(list);
    initGuide();
    initMini(rounds.length ? list : []);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
